import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useAttachments = (appointment_id: number) =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.attachments,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { appointment_id }, baseUrl)).data.data,
    enabled: false,
    refetchOnMount: false
  });
